export const REQUEST_DONATION_CATEGORY_PARENT_LIST = "REQUEST_DONATION_CATEGORY_PARENT_LIST"
export const REQUEST_DONATION_CATEGORY_LIST = "REQUEST_DONATION_CATEGORY_LIST"
export const REQUEST_DONATION_CATEGORY_LIST_FOR_CREATE = "REQUEST_DONATION_CATEGORY_LIST_FOR_CREATE"